import type { MakeCall } from '../createMakeCall';
import { PayInResource } from './types';

const getPayIn = (makeCall: MakeCall) => (uuid: string) =>
  makeCall<PayInResource>('GET', `/api/v2/payment/pay-in/${uuid}`);
export { getPayIn };
